import { formatBytes } from "./attachments.js";

/** spec14 FR8: the server widget's numbers in words. */

/** Used share in % (0 to 100), 0 for an empty total. */
export const usagePercent = (used: number, total: number) =>
  total > 0 ? Math.min(100, Math.max(0, (used / total) * 100)) : 0;

/** FR8: bars turn `important` from 80 % and `destructive` from 90 %. */
export function usageLevel(percent: number): "normal" | "high" | "critical" {
  if (percent >= 90) return "critical";
  if (percent >= 80) return "high";
  return "normal";
}

/** "12.3 / 31.1 GB": two sizes, the unit written once when both share it. */
export function formatBytePair(a: number, b: number): string {
  const left = formatBytes(a);
  const right = formatBytes(b);
  const unit = (text: string) => text.split(" ")[1];
  return unit(left) === unit(right) ? `${left.split(" ")[0]} / ${right}` : `${left} / ${right}`;
}

/** "3d 4h", "5h 12m", "12m" (seconds in, the two largest units out). */
export function formatUptime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) return `${days}d ${hours % 24}h`;
  if (hours > 0) return `${hours}h ${minutes % 60}m`;
  return `${minutes}m`;
}

/** Network throughput: "1.2 MB/s" (bytes per second in). */
export const formatRate = (bytesPerSecond: number) => `${formatBytes(bytesPerSecond)}/s`;
